import { colors } from 'inpock-ui-react/dist/src/color';
import styled from '@emotion/styled';

export const NoticeModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  border: 1px solid ${colors.gray200};
  background: ${colors.white};
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.14);
  width: calc(375px + 24px);
  overflow: hidden;

  @media (max-width: 400px) {
    width: 360px;
  }
`;

export const NoticeModalBody = styled.div`
  padding: 20px 12px 0;
`;

export const NoticeImage = styled.div`
  width: 375px;
  height: 440px;

  @media (max-width: 400px) {
    width: calc(360px - 24px);
    height: calc(420px - 24px);
  }

  img {
    width: 100%;
    height: 100%;
  }
`;

export const NoticeModalFooter = styled.div`
  .action-buttons {
    display: flex;
    gap: 8px;
    padding: 20px 12px;
  }

  .btn-modal-footer {
    &.left {
      flex: 3;
    }

    &.right {
      flex: 7;
    }
  }
`;

export const NoticeModalIgnore = styled.div`
  background-color: #f6f6f6;
  padding: 20px 0;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
